import { AsyncComponent } from '@twigeducation/async-component';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import React from 'react';
import { Route } from 'react-router-dom';
import { SpeechStream } from '@twigeducation/speechstream';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Layout from '../../layout';
import withProductSubscriptions from '../../components/withProductSubscriptions';
import AsyncComponentError from '../../components/AsyncComponentError';
import getUser from '../../helpers/getUser';

// eslint-disable-next-line react/display-name
const StudentSession = React.memo(props => (
    <AsyncComponent
        appName="ms-student-session-mfe"
        componentName="StudentSession"
        errorComponent={AsyncComponentError}
        cloudinaryUrl={window.config.CLOUDINARY_URL}
        unleash={{
            url: window.config.UNLEASH_URL,
            clientId: window.config.UNLEASH_CLIENT_ID,
        }}
        autosaveWSUrl={window.config.LESSON_ANSWER_SERVICE_WEBSOCKET_API}
        {...props}
    />
));

const ReactQuill = props => (
    <AsyncComponent
        appName="twig-quill-mfe"
        componentName="TwigQuill"
        errorComponent={AsyncComponentError}
        {...props}
    />
);

const SpeechStreamWithStartingPoints = props => {
    const user = getUser();
    const userRole = user.role;
    const isStudent = userRole;

    return (
        <SpeechStream
            {...props}
            startingPoints={['Trackerstyled__TrackerHeader*', 'termModalBody', 'speakerContent']}
            autoPlay
            showFixedToolbar={!isStudent}
            fillColor="#0D729A"
        />
    );
};

const StudentSessionPage = withProductSubscriptions(() => {
    return (
        <>
            <Breadcrumb baseSessionPath="/student-session" hideForRoles={['STUDENT']} />
            <StudentSession Layout={Layout} reactQuill={ReactQuill} SpeechStream={SpeechStreamWithStartingPoints} />
        </>
    );
});

const allowedRoles = ['STUDENT', 'TEACHER', 'SCHOOL_ADMIN', 'DISTRICT_OWNER'];
const routes = [
    <Route path="/student-session/*" key="student-session">
        <WithAuthentication roles={allowedRoles}>
            <StudentSessionPage />
        </WithAuthentication>
    </Route>,
];

export default routes;
